var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVolcano = function SvgVolcano(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.591 10.591a2.25 2.25 0 0 0 0-3.182c-.879-.879-2.462-1.038-3.341-.159-.102-.658-.445-1.041-.952-1.548a3.25 3.25 0 0 0-4.596 0c-.507.507-.85.89-.952 1.548-.879-.879-2.463-.72-3.341.159a2.25 2.25 0 0 0 0 3.182M10.75 10.25v-.5M13.252 10.25v-.5M4.75 19.25s4 0 6-6.5h2.5c2 6.5 6 6.5 6 6.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgVolcano;